import React from 'react';

import { numberWithDelimiter } from '../../utils';
import * as s from './IconWithCount.css';

interface IIconWithCount {
  count: number;
  icon: React.ReactNode;
  maxCount?: number;
}

/**
 * Иконка и число
 * Поддерживает максимальное отображаемое значение (прим., 999+)
 */
export const IconWithCount = ({ count, icon, maxCount = count }: IIconWithCount) => {
  if (count <= 0) {
    return null;
  }

  const preparedCount = count > maxCount ? `${numberWithDelimiter(maxCount)}+` : numberWithDelimiter(count);

  return (
    <div className={s['wrapper']} title={count > maxCount ? numberWithDelimiter(count) : undefined}>
      <div className={s['icon']}>{icon}</div>

      <div className={s['count']}>{preparedCount}</div>
    </div>
  );
};
